import {
  createCompositeStore
} from "../__chunks/ROY5BBHL.js";
import "../__chunks/A7IMXABC.js";
import {
  createStore
} from "../__chunks/OGOHEUXI.js";
import {
  defaultValue
} from "../__chunks/WVTCK5PV.js";
import "../__chunks/O35LWD4W.js";
import "../__chunks/5XEKIOCW.js";
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "../__chunks/PNRLI7OV.js";

// src/radio/radio-store.ts
function createRadioStore(_a = {}) {
  var props = __objRest(_a, []);
  var _a2;
  const syncState = (_a2 = props.store) == null ? void 0 : _a2.getState();
  const composite = createCompositeStore(__spreadProps(__spreadValues({}, props), {
    focusLoop: defaultValue(props.focusLoop, syncState == null ? void 0 : syncState.focusLoop, true)
  }));
  const initialState = __spreadProps(__spreadValues({}, composite.getState()), {
    value: defaultValue(
      props.value,
      syncState == null ? void 0 : syncState.value,
      props.defaultValue,
      null
    )
  });
  const radio = createStore(initialState, composite, props.store);
  return __spreadProps(__spreadValues(__spreadValues({}, composite), radio), {
    setValue: (value) => radio.setState("value", value)
  });
}
export {
  createRadioStore
};
